import React from "react";
import Slider from "react-slick";
import { HiOutlineArrowRight } from "react-icons/hi";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styled from "styled-components";
import "./HeroSlider.css";
// Styled-components matching your old setup
const Slide = styled.div`
  &.hero {
    position: relative;

    button {
      position: absolute;
      bottom: 30%;
      left: 125px;
      border: none;
      padding: 10px 20px;
      min-width: max-content;
      border-radius: 10px;
      display: flex;
      gap: 10px;
      align-items: center;
      justify-content: center;
      color: white;
      font-weight: bold;
      font-size: 16px;
      text-transform: uppercase;
      z-index: 2;

      a {
        color: inherit;
        text-decoration: none;
      }

      svg {
        font-size: 20px;
      }

      @media screen and (max-width: 1024px) {
        left: 88px;
      }
      @media screen and (max-width: 768px) {
        left: 95px;
        bottom: 25%;
      }
    }
  }
`;

const ImageContainer = styled.div`
  &.hero {
    height: 630px;
    width: 100%;

    @media screen and (max-width: 1024px) {
      height: 450px;
    }

    @media screen and (max-width: 768px) {
      width: 90%;
      margin: auto;
      height: 305px;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;

      @media screen and (max-width: 768px) {
        border-radius: 10px;
      }
    }
  }
`;

const HeroSlider = ({ heroImages }) => {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    fade: true,
    autoplaySpeed: 5000,
  };

  return (
    <Slider {...settings}>
      {heroImages.map((data) => (
        <Slide key={data.id} className="hero">
          <ImageContainer className="hero">
            <img src={data.src} alt="Slide not found" />
          </ImageContainer>
          <button style={{ background: data.bgColor }}>
            <a href={data.route}>Shop Now</a>
            <span>
              <HiOutlineArrowRight />
            </span>
          </button>
        </Slide>
      ))}
    </Slider>
  );
};

export default HeroSlider;
